import { render, staticRenderFns } from "./ChannelMultiselect.vue?vue&type=template&id=5b76bab6&"
import script from "./ChannelMultiselect.vue?vue&type=script&lang=js&"
export * from "./ChannelMultiselect.vue?vue&type=script&lang=js&"
import style0 from "./ChannelMultiselect.vue?vue&type=style&index=0&id=5b76bab6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports